/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteMachineTypeModal_machineType$ref: FragmentReference;
declare export opaque type DeleteMachineTypeModal_machineType$fragmentType: DeleteMachineTypeModal_machineType$ref;
export type DeleteMachineTypeModal_machineType = {|
  +id: string,
  +name: string,
  +$refType: DeleteMachineTypeModal_machineType$ref,
|};
export type DeleteMachineTypeModal_machineType$data = DeleteMachineTypeModal_machineType;
export type DeleteMachineTypeModal_machineType$key = {
  +$data?: DeleteMachineTypeModal_machineType$data,
  +$fragmentRefs: DeleteMachineTypeModal_machineType$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeleteMachineTypeModal_machineType",
  "type": "MachineType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '84f71fd4dafd493dd46e955a705819cb';
module.exports = node;
